export var MultivariateEnrolment;
(function (MultivariateEnrolment) {
    MultivariateEnrolment["NOT_ENROLLED"] = "not-enrolled";
    MultivariateEnrolment["CONTROL"] = "control";
    MultivariateEnrolment["VARIATION"] = "variation";
})(MultivariateEnrolment || (MultivariateEnrolment = {}));
